import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TurnSharpLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"turn_sharp_left"}/>
}
